.email {
  font-weight: 600;
}

.muted {
  color: var(--text-muted);
  font-size: 0.85rem;
}

.youTag {
  margin-left: 8px;
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--accent, #4f46e5);
}

.rowActions {
  display: flex;
  justify-content: flex-end;
}

.dialogBody {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* Who the password is being changed for, restated inside the dialog. The
   table row is no longer in view once the modal is open, and setting the
   wrong colleague's password is a silent, confusing failure. */
.target {
  padding: 12px 14px;
  border: 1px solid var(--border);
  border-radius: var(--radius-md, 8px);
  background: var(--surface-sunken, var(--surface));
}

.targetLabel {
  display: block;
  color: var(--text-muted);
  font-size: 0.8rem;
  margin-bottom: 2px;
}

.targetValue {
  font-weight: 600;
  word-break: break-all;
}

.formActions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

/* The generated password, shown exactly once. Monospace and roomy because it
   gets read aloud or copied by hand, and an l/1 or O/0 mistake means a
   locked-out colleague and a second reset. */
.passwordBox {
  padding: 16px;
  border: 1px solid var(--border);
  border-radius: var(--radius-md, 8px);
  background: var(--surface-sunken, var(--surface));
  font-family: ui-monospace, "Cascadia Code", "Source Code Pro", monospace;
  font-size: 1.25rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-align: center;
  word-break: break-all;
}

.roleHint {
  margin-top: 4px;
  color: var(--text-muted);
  font-size: 0.82rem;
  line-height: 1.45;
}
